module.exports = __webpack_public_path__ + "static/img/new-banner.906d280.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/scan/new-banner.jpg
// module id = +QW+
// module chunks = 1